export default {
  "HitPaw Add Music to Audio Online": "HitPawはオンラインの音声データに音楽を加える",
  "Add BGM to Audio without any difficulties.": "簡単にBGMを音声データに加えます。",
  "Add New": "新しいものに加える",
  "Format": "形式",
  "Add tracks": "トラックを追加する",

};
